export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13550.5ab51822.jpg";